import {Injectable} from '@angular/core';
import {UserService} from "../services/user.service";
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';


@Injectable()
export class ConfigurationService {
    constructor(private http: HttpClient, private router: Router, private userService: UserService) {
    }

    public getAllCurrencies(type): Observable<any> {
        return this.userService.userequest('get', 'getcurrencylist', null, {type: type});
    }

    public changeStatus(id, status): Observable<any> {
        return this.userService.userequest('get', 'changeStatus', null, {id: id, status: status})

    }

    public getRefsettings(): Observable<any> {
        return this.userService.userequest('get', 'getreferral');
    }
    public updateRefsettings(obj): Observable<any> {
        return this.userService.userequest('post', 'updatereferal', obj);
    }

    public getAdminSettings(): Observable<any> {
        return this.userService.userequest('get', 'getAdminSettings');
    }
    public updateAdminSettings(obj): Observable<any> {
        return this.userService.userequest('post', 'updateAdminSettings', obj);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/configuration.service.ts